import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatService {
  toCamelCase(text: string): string {
    return text.charAt(0).toLowerCase() + text.substring(1);
  }

  toPascalCase(text: string): string {
    return text.charAt(0).toUpperCase() + text.substring(1);
  }

  toSentenceCase(text: string, convertToLowerCase: boolean = true): string {
    let result = text != 'HomeMover' ? text.replace(/([A-Z])/g, ' $1').trim() : 'Homemover';
    if (convertToLowerCase) {
      result = result.toLowerCase();
    }
    return result.charAt(0).toUpperCase() + result.substring(1);
  }

  getEnumPropertyNames(enumeration: any): string[] {
    return Object.keys(enumeration).filter((key) => !isNaN(Number(enumeration[key])));
  }

  formatCurrency(value: string | number): string | null {
    if (!value) {
      return null;
    }

    value = value
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      .replace(/^0{2,}/, '0')
      .replace(/^0([1-9])/, '$1');
    return value;
  }
}
